import { Card } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface ServiceCardProps {
  title: string;
  description: string;
  features: string[];
  icon: LucideIcon;
  gradient: string;
  glowClass: string;
  textGlowClass: string;
  serviceColor: string;
}

const ServiceCard = ({ 
  title, 
  description, 
  features, 
  icon: Icon, 
  gradient,
  glowClass,
  textGlowClass,
  serviceColor
}: ServiceCardProps) => {
  return (
    <Card className={`glass hover-glow ${glowClass} group cursor-pointer transition-all duration-500 border-surface-variant`}>
      <div className="p-8 h-full flex flex-col">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <div className={`p-3 rounded-lg ${gradient} ${glowClass}`}>
            <Icon className="w-8 h-8 text-background" />
          </div>
          <h3 className={`text-2xl font-bold ${textGlowClass} group-hover:scale-105 transition-all`}>
            {title}
          </h3>
        </div>

        {/* Description */}
        <p className="text-muted-foreground mb-6 flex-grow leading-relaxed">
          {description}
        </p>

        {/* Features */}
        <div className="mb-6">
          <h4 className="text-sm font-semibold text-foreground mb-3 uppercase tracking-wider">
            Key Features
          </h4>
          <ul className="space-y-2">
            {features.map((feature, index) => (
              <li key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
                <div className={`w-1.5 h-1.5 rounded-full`} style={{ backgroundColor: serviceColor }}></div>
                {feature}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Card>
  );
};

export default ServiceCard;